export default {
    menus() {
        return [
            {
                label: '首页',
                pages: [
                    { label: '欢迎光临', path: 'home' },
                ]
            }, {
                label: 'Pignoo',
                pages: [
                    { label: 'Hi! Pignoo', path: 'pignoo' },
                    { label: '入门', path: 'pignooBegin' },
                    { label: '对象映射', path: 'pignooMapper' },
                    { label: '读操作', path: 'pignooReader' },
                    { label: '写操作', path: 'pignooWriter' },
                    { label: '格鲁（Gru）', path: 'pignooGru' },
                    { label: '配置', path: 'pignooConfig' },
                    { label: '迭代器', path: 'pignooIterator' },
                    { label: 'Spring', path: 'pignooSpring' },
                    { label: '自动数据库', path: 'pignooAutodatabase' },
                ]
            }
        ]
    },
    filter(hidden, paths) {
        const menus = this.menus()
        for (let menuIndex = menus.length - 1; menuIndex >= 0; menuIndex--) {
            const menu = menus[menuIndex]
            if (menu != null && menu.pages != null) {
                for (let pageIndex = menu.pages.length - 1; pageIndex >= 0; pageIndex--) {
                    let splice = false
                    const page = menu.pages[pageIndex]
                    if (hidden === true && !page.hidden) {
                        splice = true
                    }
                    if (hidden === false && page.hidden) {
                        splice = true
                    }
                    if (paths != null && paths.length > 0 && !paths.includes(page.path)) {
                        splice = true
                    }
                    if (splice) {
                        menu.pages.splice(pageIndex, 1)
                    }
                }
            }
            if (menu == null || menu.pages == null || menu.pages.length == 0) {
                menus.splice(menuIndex, 1)
            }
        }
        return menus
    }
}